import { Navigate, useLocation } from 'react-router-dom';

/**
 * Auth guard — wraps protected routes.
 * Checks for auth_token in localStorage; redirects to /login if missing.
 *
 * To logout: localStorage.removeItem('auth_token') then navigate('/login')
 */
export function AuthGuard({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const token = localStorage.getItem('auth_token');

  if (!token) {
    return <Navigate to={'/login'} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

/** Call this to sign out — clears storage and returns the login path. */
export function logout(): string {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user_email');
  localStorage.removeItem('user_name');
  localStorage.removeItem('user_role');
  localStorage.removeItem('account_id');
  return '/login?msg=session_expired';
}
